export enum AuctionStatus {
  /**
   * 待发布
   */
  WAIT_PUBLISH = 0,
  /**
   * 待审核
   */
  WAIT_AUDIT = 1,
  /**
   * 审核通过
   */
  AUDIT_SUCCESS = 2,
  /**
   * 审核不通过
   */
  AUDIT_FAIL = 3,
  /**
   * 委托方已确认
   */
  ENTRUST_CONFIRMED = 4,
  /**
   * 已成交
   */
  DEAL = 5,
  /**
   * 部分成交
   */
  DEAL_PART = 6,
  /**
   * 流拍
   */
  DEAL_FAIL = 7,
  /**
   * 委托方终止交易
   */
  ENTRUST_HALT = 8,
  /**
   * 终止未通过
   */
  HALT_FAIL = 9,
  /**
   * 已终止
   */
  HALT_SUCCESS = 10
}

export const AuctionStatusTextMap = {
  [AuctionStatus.WAIT_PUBLISH]: '待发布',
  [AuctionStatus.WAIT_AUDIT]: '待审核',
  [AuctionStatus.AUDIT_SUCCESS]: '审核通过',
  [AuctionStatus.AUDIT_FAIL]: '审核不通过',
  [AuctionStatus.ENTRUST_CONFIRMED]: '委托方已确认',
  [AuctionStatus.DEAL]: '已成交',
  [AuctionStatus.DEAL_PART]: '部分成交',
  [AuctionStatus.DEAL_FAIL]: '流拍',
  [AuctionStatus.ENTRUST_HALT]: '委托方终止交易',
  [AuctionStatus.HALT_FAIL]: '终止未通过',
  [AuctionStatus.HALT_SUCCESS]: '已终止'
}
